import React, { useEffect, useRef, useState } from 'react'
import { postAPI } from '../../app/api'
import { setStore, store } from '../../app/store'
import LoginImg from "../../theme/assets/img/Two-factor-authentication-rafiki.svg"
import LogoImg from "../../theme/assets/img/wt-logo.png"
import { useParams } from 'react-router-dom'
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

export default function ForgetPassword() {
  const { server_id, user_type, username, reset_token } = useParams();
  const [FormData, setFormData] = useState({})
  const [IsBTNClicked, setIsBTNClicked] = useState(false);

  const handleChange = e => {
    const { name, value } = e?.target;
    setFormData({ ...FormData, [name]: value })
  }

  const sendResetLink = async (server_id, user_type, username) => {
    try {
      const response = await postAPI("/super_admin/architecture/auth_handle/request-reset-password", {server_id: server_id, user_type: user_type, username: username});
      // console.log(response)
      if (response?.data?.res == 1) {
        window.location.href = '/Success'
        setIsBTNClicked(false);
        toast.success(`Great Job ! ${response?.data?.msg} .`);
      } else {
        setIsBTNClicked(false);
        toast.error(`Sorry ! ${response?.data?.msg}`);
      }
    } catch (e) {
      setIsBTNClicked(false);
      toast.error('Sorry ! Something Wrong. Please try again.');
      // console.log("Exception Error: ", e?.response?.data?.error)
    }
  }

  const handleSubmitForgetPassword = async () => {
    setIsBTNClicked(true);
    const server = FormData?.server || "";  // fallback to empty if undefined

    // Split once at the first dot
    const [user_type, ...rest] = server.split(".");
    const server_id = rest.join("."); // in case server_id includes more than one dot

    console.log("User Type:", user_type);   // "admin"
    console.log("Server ID:", server_id);   // "xyz.com"
    if (IsBTNClicked) {
    } else {
      sendResetLink(server_id, user_type, FormData?.username);
    }
  }

  return (
    <>
      <div class="main-wrapper log-wrap LoginPage">
        <div class="row">
          <div class="col-md-6 login-bg">
            <div class="welcome-login">
              <div class="login-banner"><img class="img-fluid" src={LoginImg} alt="Logo" /></div>
              <div class="text-center mentor-course">
                <h2>Welcome to <br />Architecture</h2>
                <p>Forgot your password? Reset your password using your registered email.</p>
              </div>
            </div>
          </div>
          <div class="col-md-6 login-wrap-bg">
            <div class="login-wrapper">
              <div class="loginbox">
                <div class="img-logo"><img class="img-fluid" src={LogoImg} alt="Logo" style={{ width: "180px" }} />
                </div>
                <h1>Forgot Password ?</h1>
                <div class="reset-password">
                  <p>Enter your server & username to reset your password.</p>
                </div>
                <form>
                  <div class="form-group">
                    <label class="form-control-label">Server</label>
                    <input class="form-control" type="text" name='server' onChange={handleChange} placeholder="Enter your server" />
                  </div>
                  <div class="form-group">
                    <label class="form-control-label">Username</label>
                    <input class="form-control" type="text" name='username' onChange={handleChange} placeholder="Enter your username" />
                  </div>
                  <div class="d-grid">
                    <button class="btn btn-start" type="button" onClick={handleSubmitForgetPassword}>{IsBTNClicked ? <> <i class="fas fa-circle-notch fa-spin"></i> &nbsp; &nbsp; </> : <></>}Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
    </>
  )
}
